import { TEMPLATES } from "../routes/RouteCreateRequirementByTemplate/templates";
import { RequirementDefinitionTemplate } from "../routes/RouteCreateRequirementByTemplate/types";

export function getRequirementDefinitionTemplates(
  showHidden?: boolean
): RequirementDefinitionTemplate[] {
  return TEMPLATES.filter(template => (showHidden ? true : !template.hidden));
}
